/** @jsx jsx */
import React from "react";
import { css, jsx } from '@emotion/react';
import { IconNames } from '@blueprintjs/icons';
import { Icon, Menu, MenuItem } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';

import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import { GenericObject } from 'interfaces/GenericObject';

/**
 *
 * @description Wrapper for ObjectDropdown that provides a dropdown name
 */
export const Filter = ({ options, selectedItem, onSelectionChanged }) => {
	return (
		<div css={filterStyle} className={"flex-row"}>
			<Popover2 placement={"bottom"} content={
				<Menu>
					{
						options?.map(k => <Option active={selectedItem === k} key={k.key} onClick={onSelectionChanged} item={k}/>)
					}
				</Menu>
			}>
				<React.Fragment>
					<Icon icon={IconNames.TIME}/>
					<Icon icon={IconNames.CARET_DOWN}/>
				</React.Fragment>
			</Popover2>
		</div>
	);
};

function Option({onClick, active, item}) {
	const _onClick= () => {
		onClick(item);
	}
	return <MenuItem active={active} text={item.key} onClick={_onClick}/>
}


export interface FilterProps {
	options: Array<FilterOption>,
	onSelectionChanged: (arg: FilterOption) => void;
	selectedItem: FilterOption;
}

export interface FilterOption extends GenericObject<any> {
	key: string;
}

const filterStyle = css`
	align-items: center;
	margin: auto 0 auto auto;
	justify-content: center;
	position: relative;

	& .filter-title {
		margin-right: 5px;
	}
	
	& .bp3-icon-caret-down {
		//margin-top did nothing and margin-bottom worked but cause time icon to also move down
		position: relative;
		top: -6px;
	}
`;
